const __WEBPACK_NAMESPACE_OBJECT__ = kolibriCoreAppGlobal["kolibri/utils/i18n"];